import axios from 'axios';
import { mainAPIUrl } from '../../../settings';

const baseURL = `${mainAPIUrl}/gservices_3/messages`;

// Card.js
export const fetchMessageAPICall = async (tokenId) => {
  const url = `${baseURL}/${tokenId}`;

  if (tokenId == null) {
    return null;
  } else {
    try {
      const res = await axios.get(url);
      const currentMessage = res.data.data;

      return currentMessage;
    } catch (error) {
      // Add context to error before re-throwing for better upstream logging
      if (error && typeof error === 'object') {
        error.tokenId = tokenId;
        error.url = url;
      }
      // Re-throw the error so Card.js can handle it with proper error classification
      throw error;
    }
  }
};
